import { render } from "./ServicesPerUserTable.vue?vue&type=template&id=c206a53a"
import script from "./ServicesPerUserTable.vue?vue&type=script&lang=js"
export * from "./ServicesPerUserTable.vue?vue&type=script&lang=js"

import "./ServicesPerUserTable.vue?vue&type=style&index=0&id=c206a53a&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__